import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment, CanActivate } from '@angular/router';
import { CognitoService } from '../services/cognito.service';
import { UserService } from '../services/user.service';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class IsLoggedGuard implements CanActivate {
  constructor(
    private cognitoService: CognitoService, 
    private userService: UserService, 
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any
    ) { 
  }
  canActivate(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.checkSession()
        .then((res) => {
          if (res) {
            resolve(true);
          } else {
            if (location.hostname === 'localhost') {
              window.location.href = 'https://localhost:4200/open-id-connect/auth/builder';
            } else {
              window.location.href = environment.backUrl+"/open-id-connect/auth/builder";
            }
            resolve(false);
          }
        });
    });
  }

  /* Function for checking if user is logged in
    * checks if user is loggedin, also checks if token expires soon, then renews it,
    * if not logged in, returns 'not_logged_in'
    */
  checkSession(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (isPlatformBrowser(this.platformId)) {
        this.cognitoService.checkSessionAndRenew()
        .then((res) => {
          resolve(true);
        }, (err) => {
          // // If user not logged in, redirect him to Login page
          // this.router.navigate(['auth/login']);
          resolve(false);
        });
      } else {
        resolve(false);
      }
    });

  }
}
